import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ddbd35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Füge ein neues FAQ-Paar hinzu und stelle so weitere Informationen für deine Nutzer bereit. Ein FAQ-Paar enthält immer Beispieläußerungen und die dazu gehörigen Antworten. ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "FAQ-Paar", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Abbrechen")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("FAQ-Paaar löschen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "FAQ-Paar löschen",
    icon: "delete_forever",
    variant: "delete"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2,
      _createElementVNode("h4", null, _toDisplayString(_ctx.faq.name), 1)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        mode: "delete",
        onClick: _ctx.deleteFaqPair
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}